const GA_ID = 'G-BB4MBP51QP';
const FB_PIXEL_ID = '1328702838301394';
const CRISP_ID = 'bdc41e3d-8d94-4952-b047-c24fdbee72c3';

/** Дополнительная задержка после старта загрузки GA/Pixel, до подключения Crisp. */
const CRISP_EXTRA_DELAY_MS = 8000;

let analyticsLoaded = false;
let crispLoaded = false;

/** Заглушка в стиле официального сниппета Meta: ранние вызовы fbq попадают в очередь. */
function installFbqStub(win: Window) {
  const w = win as Window & Record<string, unknown>;
  if (w.fbq) return;

  // eslint-disable-next-line prefer-rest-params
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };

  w.fbq = n;
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
}

function loadDeferredAnalytics() {
  if (analyticsLoaded) return;
  analyticsLoaded = true;

  const w = window as Window & {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    fbq?: (cmd: string, ...args: unknown[]) => void;
  };

  const gtagEl = document.createElement('script');
  gtagEl.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  gtagEl.async = true;
  document.head.appendChild(gtagEl);
  gtagEl.onload = () => {
    w.dataLayer = w.dataLayer || [];
    const gtag = function (this: unknown) {
      w.dataLayer!.push(arguments as unknown);
    };
    (w as { gtag?: typeof gtag }).gtag = gtag;
    (gtag as (cmd: string, ...rest: unknown[]) => void)('js', new Date());
    (gtag as (cmd: string, ...rest: unknown[]) => void)('config', GA_ID);
  };

  const fbEl = document.createElement('script');
  fbEl.src = 'https://connect.facebook.net/en_US/fbevents.js';
  fbEl.async = true;
  const first = document.getElementsByTagName('script')[0];
  first?.parentNode?.insertBefore(fbEl, first);
  w.fbq!('init', FB_PIXEL_ID);
  w.fbq!('track', 'PageView');

  window.setTimeout(loadCrispLazy, CRISP_EXTRA_DELAY_MS);
}

function loadCrispLazy() {
  if (crispLoaded) return;
  crispLoaded = true;

  const crispEl = document.createElement('script');
  crispEl.src = 'https://client.crisp.chat/l.js';
  crispEl.async = true;
  document.head.appendChild(crispEl);
}

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  const w = window as Window & { $crisp?: unknown[]; CRISP_WEBSITE_ID?: string };
  w.$crisp = w.$crisp || [];
  w.CRISP_WEBSITE_ID = CRISP_ID;

  installFbqStub(window);

  const start = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => loadDeferredAnalytics(), { timeout: 3500 });
    } else {
      setTimeout(loadDeferredAnalytics, 2000);
    }
  };

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
});
